var _style, _g, _g2, _g3, _g4, _g5, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpertreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 203.1 173.8",
    style: {
      enableBackground: "new 0 0 203.1 173.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.8,0.8C65.9,0.8,36,20.4,36,44.7s29.9,43.9,66.8,43.9c0.4,0,0.8,0,1.2,0c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.1,0c36.2-0.5,65.3-20,65.3-43.9C169.6,20.4,139.7,0.8,102.8,0.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 57.1,
    cy: 91.6,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 43.6,
    cy: 104.1,
    r: 4.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.6,173.3c-26.5,1.5-39.7,1.5-66.1,0.5c0-0.2,0-0.3,0-0.5c-0.2-12.3,6.6-23.7,17.4-29.5 c4.2,3.4,9.4,5.2,14.8,5.2c5.6-0.1,11-2.2,15.1-5.9c11.3,5.4,18.6,16.8,18.8,29.4l0,0C65.6,172.8,65.6,173.1,65.6,173.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,140.9c-2.7,2.2-6.1,3.4-9.8,3.5c-3.6,0.1-6.9-1.1-9.6-3c-1.6-1.2-3-2.6-4.1-4.3c-1.6-2.5-2.6-5.4-2.6-8.6 c-0.1-8.9,7-16.3,16-16.4c8.9-0.1,16.3,7,16.4,16c0,3.4-0.9,6.5-2.7,9.1C43.6,138.6,42.4,139.9,41,140.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.6,172.6c-26.5,1.5-39.7,1.5-66.1,0.5c0-0.2,0-0.3,0-0.5c-0.2-12.3,6.6-23.7,17.4-29.5 c4.2,3.4,9.4,5.2,14.8,5.2c5.6-0.1,11-2.2,15.1-5.9c11.3,5.4,18.6,16.8,18.8,29.4l0,0C202.6,172.1,202.6,172.4,202.6,172.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178,140.2c-2.7,2.2-6.1,3.4-9.8,3.5c-3.6,0.1-6.9-1.1-9.6-3c-1.6-1.2-3-2.6-4.1-4.3c-1.6-2.5-2.6-5.4-2.6-8.6 c-0.1-8.9,7-16.3,16-16.4c8.9-0.1,16.3,7,16.4,16c0,3.4-0.9,6.5-2.7,9.1C180.6,137.9,179.4,139.2,178,140.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.6,81.8c5,0,9,4,9,9c0,5-4,9-9,9c-5,0-9-4-9-9C136.5,85.9,140.6,81.8,145.6,81.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159.1,
    cy: 103.4,
    r: 4.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertreview);
export default __webpack_public_path__ + "static/media/Expertreview.030a50bb6a53cdcd763ba78d8fa7bde9.svg";
export { ForwardRef as ReactComponent };